<!-- HEADER	-->
<div
	*ngIf="groupConfig?.renderHeader"
	class="group-header"
	[ngClass]="{
		'pe-none': !groupConfig.collapsable,
		'disabled': groupConfig.disabled
	}"
	(click)="toggleCollapsedState()"
	(mouseenter)="isHovered = true"
	(mouseleave)="isHovered = false"
>
	<ng-container
		*ngTemplateOutlet="groupHeaderTpl"
	></ng-container>
</div>

<hr *ngIf="groupConfig?.showHeaderSeparator" class="group-separator"/>

<!-- CONTENT -->
<div
	class="group--content"
	[ngbCollapse]="isCollapsed"
>
	<!-- Projected	-->
	<ng-content select=".group-main-content"></ng-content>
</div>

<!-- FOOTER	-->
<hr *ngIf="groupConfig?.showFooterSeparator" class="group-separator"/>

<div class="group--footer">
	<!-- Projected	-->
	<ng-content select=".group-footer-content"></ng-content>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- Group Header -->
<ng-template #groupHeaderTpl>

	<!-- Icon	-->
	<i
		*ngIf="groupConfig?.showToggleIcon"
		class="me-2 align-middle {{ groupConfig?.toggleIconClass ? groupConfig?.toggleIconClass : 'group-header-toggleIcon fs-l fw-medium' }}"
		[ngClass]="{
			'ft-chevron-right': isCollapsed,
			'ft-chevron-down': !isCollapsed,
			'hovered': isHovered
		}"
	></i>

	<!-- Label	-->
	<label
		*ngIf="groupConfig?.showLabel"
		class="d-inline-block align-middle {{ groupConfig?.labelClass ? groupConfig?.labelClass : 'group-header--label fs-md fw-medium m-0' }}"
		[ngClass]="{
			'hovered': isHovered
		}"
	>
		{{ getValueByGroupValueType() }}
	</label>

	<!-- Projected	-->
	<ng-content select=".group-header-content"></ng-content>

</ng-template>
